import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import About from './sections/About';
import PNF from './sections/PNF';
import WorkingOff from './sections/WorkingOff';
import KeyDirections from './sections/KeyDirections';
import NewRole from './sections/NewRole';
import Timeline from './sections/Timeline';
import Management from './sections/Management';
import Investors from './sections/Investors';
import News from './sections/News';
import FAQ from './sections/FAQ';
import Contacts from './sections/Contacts';
import Footer from './sections/Footer';
import PreviewModal from './sections/PreviewModal';
import { LanguageProvider } from './context/LanguageContext';
import { VisionAccessibilityProvider } from './context/VisionAccessibilityContext';
import VisionAccessibilityBar from './components/VisionAccessibilityBar';
import './index.css';
import './styles/accessibility-vision.css';

function App() {
  return (
    <LanguageProvider>
      <VisionAccessibilityProvider>
      <VisionAccessibilityBar />
      <Navbar />
      <Hero />
      <About />
      <PNF />
      <WorkingOff />

      <NewRole />
      <Timeline />
      <Management />
      <Investors />
      <News />
      <FAQ />
      <Contacts />
      <Footer />
      <PreviewModal />
      </VisionAccessibilityProvider>
    </LanguageProvider>
  );
}

export default App;